import { render } from "./ApplicationLenta.vue?vue&type=template&id=bfa584ac&scoped=true"
import script from "./ApplicationLenta.vue?vue&type=script&lang=js"
export * from "./ApplicationLenta.vue?vue&type=script&lang=js"

import "./ApplicationLenta.vue?vue&type=style&index=0&id=bfa584ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa584ac"]])

export default __exports__